import SideDish from '@components/offer/models/SideDish';
import { Box, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';

interface SideDishBaseButtonProps {
    sideDish: SideDish;
    onClick: (sideDish: SideDish) => void;
    children: React.ReactNode;
}

const SideDishBaseButton: React.FC<SideDishBaseButtonProps> = observer(({ sideDish, onClick, children }) => {
    var isSelected = sideDish.isSelected;
    return (
        <Paper sx={(theme) => ({
            pt:0.25,
            pb: 0.25,
            cursor: { sm: "pointer" },
            // boxShadow: isSelected ? theme.shadows[8] : theme.shadows[8],
            borderRadius: 0.5,
            // backgroundColor: isSelected ? theme.palette.secondary.light : "Background",

            ":hover": {
                boxShadow: { sm: theme.shadows[8] }
            }
        })} elevation={0}>
            <Box width={"100%"} pl={0.5} display={"flex"} alignItems={"center"} onClick={() => onClick(sideDish)}>
                <Box>
                    {isSelected ? <CheckedIcon/> : <UnCheckedIcon/>}
                </Box>
                {children}
            </Box>
        </Paper>

    )
})

export default SideDishBaseButton;

const UnCheckedIcon = () => {
    return (
        <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"1.6rem"}
        height={"1.6rem"}>
        <Paper
            elevation={6}
            sx={{
                width: "1.3rem",
                height: "1.3rem",
                borderRadius: 0.2
            }} />
    </Box>
    )
}

const CheckedIcon = () => {
    return (
        <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"1.6rem"}
        height={"1.6rem"}>
<CheckBoxTwoToneIcon sx={{ width: "1.7rem", height: "1.7rem"}} color='secondary' /> 
    </Box>  
    )
}